import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Svg, { Defs, Ellipse, LinearGradient, Path, Rect, Stop } from 'react-native-svg';

export default function BrandMark({
  size = 46,
  title = 'PanenKu',
  subtitle = 'AI Crop Intelligence',
  light = false,
  compact = false,
}) {
  const titleColor = light ? '#F8FFFA' : '#163126';
  const subtitleColor = light ? '#D2E8D8' : '#5B7368';
  const ringColor = light ? 'rgba(183, 230, 205, 0.68)' : 'rgba(12, 66, 42, 0.12)';
  const labelGap = compact ? 8 : 11;

  return (
    <View style={[s.row, { gap: labelGap }]}>
      <View style={[s.logoWrap, { width: size, height: size, borderRadius: Math.round(size * 0.3), borderColor: ringColor }]}>
        <Svg width={size} height={size} viewBox="0 0 48 48" fill="none">
          <Defs>
            <LinearGradient id="panenkuBg" x1="5" y1="6" x2="43" y2="44" gradientUnits="userSpaceOnUse">
              <Stop offset="0" stopColor={light ? '#2D8D62' : '#0D5236'} />
              <Stop offset="1" stopColor={light ? '#146141' : '#0A3C29'} />
            </LinearGradient>
            <LinearGradient id="panenkuGrain" x1="23" y1="10" x2="31" y2="25" gradientUnits="userSpaceOnUse">
              <Stop offset="0" stopColor="#F6D97A" />
              <Stop offset="1" stopColor="#E9B84F" />
            </LinearGradient>
          </Defs>

          <Rect x="1" y="1" width="46" height="46" rx="14" fill="url(#panenkuBg)" />

          <Path
            d="M7.6 35.2C13.8 32.4 20.5 31.2 27.7 31.7C34 32.1 38.9 34.2 42 36.6"
            stroke="#D0ECD6"
            strokeWidth="1.8"
            strokeLinecap="round"
            opacity="0.82"
          />
          <Path
            d="M7.8 39.3C14.6 36.8 22 35.9 30.1 36.4C35.2 36.8 39.4 38.1 42.4 39.6"
            stroke="#D0ECD6"
            strokeWidth="1.4"
            strokeLinecap="round"
            opacity="0.64"
          />

          <Path
            d="M19.6 35.9V14.8"
            stroke="#F4FBF5"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <Path
            d="M19.6 16.6H26.3C29.4 16.6 31.8 19.1 31.8 22.1C31.8 25.3 29.4 27.8 26.3 27.8H19.6"
            stroke="#F4FBF5"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          <Path
            d="M22.4 16.2C27.3 15.8 31 13 32.8 9.3C28.4 9.7 24.2 11.7 22.4 16.2Z"
            fill="url(#panenkuGrain)"
          />
          <Ellipse cx="27.9" cy="12.1" rx="1.8" ry="1.05" transform="rotate(-24 27.9 12.1)" fill="#F2CE68" />
          <Ellipse cx="26.9" cy="14.5" rx="1.6" ry="0.95" transform="rotate(-22 26.9 14.5)" fill="#F2CE68" />
          <Ellipse cx="25.7" cy="16.8" rx="1.4" ry="0.88" transform="rotate(-18 25.7 16.8)" fill="#F2CE68" />
          <Path
            d="M19.6 18.4C17.5 17.2 16.2 15.5 15.5 13.1"
            stroke="#F4FBF5"
            strokeWidth="1.5"
            strokeLinecap="round"
            opacity="0.95"
          />
        </Svg>
      </View>

      {!compact && (
        <View>
          <Text style={[s.title, { color: titleColor }]}>{title}</Text>
          <Text style={[s.subtitle, { color: subtitleColor }]}>{subtitle}</Text>
        </View>
      )}
    </View>
  );
}

const s = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center' },
  logoWrap: {
    borderWidth: 1,
    overflow: 'hidden',
  },
  title: { fontSize: 20, fontWeight: '900', letterSpacing: 0.22 },
  subtitle: { marginTop: 2, fontSize: 11.5, fontWeight: '700', letterSpacing: 0.24 },
});
